// extracted by mini-css-extract-plugin
export var button = "_kr-0";
export var donut = "_kr-1";
export var donutFill = "_kr-3";
export var donutTrack = "_kr-2";